import { db } from '../firebase';
import { dispatch } from '../../store'
import { LISTEN_MESSAGING_INBOX } from '../../constants/actionTypes'
import _ from 'lodash'
const refMessaging = db.ref('/messages')

export const doListenMessagingInbox = async (userId) => {
   //const myInboxSnap = await refMessaging.child(userId).child('inbox').on('value')
   refMessaging.child(userId).child('inbox').on('value', myInboxSnap =>{
       // if snapshot not exisiting dispatch null
        if(!myInboxSnap.exists()){
                const payload = {
                    myInbox: [],
                    inboxCouner: 0,
                }

                return dispatch({type: LISTEN_MESSAGING_INBOX, payload}) 
               // return dispatch({type: MESSAGING_INBOX_COUNTER, inboxCounter})
        }
        
        const myInbox = _.values(myInboxSnap.val())
        const inboxCounter = myInbox.length
        const payload = {
            myInbox: myInbox,
            inboxCounter: inboxCounter
        }
       
        return dispatch({type: LISTEN_MESSAGING_INBOX, payload})
       
     
        //console.log(inboxCounter)
        //return dispatch({type: MESSAGING_INBOX_COUNTER, payload: inboxCounter})
    })
}

export const doDeleteMessage = (userId, messageId) =>{
    refMessaging.child(userId).child('inbox').child(messageId).remove()
}


// WEBPACK FOOTER //
// ./src/firebase/database/handleMessaging.js